import { faDoorOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, Space, Typography } from 'antd';
import { FC } from 'react';

import { Link } from 'react-router-dom';

import navigateButton from '../../assets/audio/UI_Select_2.wav';

interface CreditsPageProps extends React.PropsWithChildren { }
const WarScholarCreditsProps: FC<CreditsPageProps> = () => {

   const playNavigationSound = () => {
      new Audio(navigateButton).play();
   };



   return (
      <div className='p-2'>

         <Typography.Title>Credits</Typography.Title>
         <Space size="large">
            <Link to="/warscholar">
               <button onClick={playNavigationSound}>
                  <FontAwesomeIcon icon={faDoorOpen} /> Back
               </button>
            </Link>
         </Space>

         <Row >
            <p>Game development by Kay and Reece</p>
         </Row>




         <p>3D Assets by</p>

         <Row>
            <p><a
               href='https://syntystore.com/'
               target="_blank"
               rel="noopener noreferrer"
            >Synty</a></p>
         </Row >


         <p>Music by</p>
         <Row>

            <p><a
               href='https://soundcloud.com/xdeviruchi'
               target="_blank"
               rel="noopener noreferrer"
            >Marllon Silva / xDeviruchi </a></p>
         </Row >


         <p>Sound effects by</p>

         <Row>
            <p><a
               href='http://www.littlerobotsoundfactory.com'
               target="_blank"
               rel="noopener noreferrer"
            >Little Robot Sound Factory</a></p>
         </Row >

         <Row>
            <p><a
               href='https://daviddumaisaudio.gumroad.com/'
               target="_blank"
               rel="noopener noreferrer"
            >DavidDumaisAudio</a></p>
         </Row>

         <Row>
            <p><a
               href='https://olexmazur.itch.io/fantasy-card-game'
               target="_blank"
               rel="noopener noreferrer"
            >Olex Mazur</a></p>
         </Row>

         <p><a
            href='https://pixabay.com/sound-effects/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=45747'
            target="_blank"
            rel="noopener noreferrer"
         >Pixabay</a></p>



      </div>
   );
};

export const WarScholarCreditsPage = WarScholarCreditsProps;

